import React from 'react';
import type { TableRow } from './shared';
import {
  Article,
  Callout,
  Clause,
  DataTable,
  EmailLink,
  PageShell,
  SubItem
} from './shared';

export default function PrivacyPolicy() {
  const tocItems = [
    { href: '#s1', label: '1. 수집하는 개인정보 항목 및 이용 목적' },
    { href: '#s2', label: '2. 만 14세 미만 아동 개인정보 보호' },
    { href: '#s3', label: '3. 개인정보 보유 기간 및 파기' },
    { href: '#s4', label: '4. 개인정보의 제3자 제공' },
    { href: '#s5', label: '5. 개인정보처리 위탁' },
    { href: '#s6', label: '6. 개인정보의 국외 이전' },
    { href: '#s7', label: '7. 개인정보 보안 관리' },
    { href: '#s8', label: '8. 쿠키 운영 및 거부 방법' },
    { href: '#s9', label: '9. 행태정보 수집·활용 안내' },
    { href: '#s10', label: '10. 회원 및 법정대리인의 권리와 행사 방법' },
    { href: '#s11', label: '11. 개인정보 보호책임자' },
    { href: '#s12', label: '12. 개인정보 침해 시 구제 기관' },
    { href: '#s13', label: '13. 방침 변경 안내' }
  ];

  const s1Headers = [
    '법적 근거',
    '수집 시점',
    '이용 목적',
    '수집 항목',
    '보유 기간',
    '구분'
  ];
  const s1Rows: TableRow[] = [
    {
      '법적 근거': '「개인정보보호법」제15조①4호',
      '수집 시점': '회원가입',
      '이용 목적': '계정 생성 및 본인 확인',
      '수집 항목':
        '[보호자] 이름(닉네임), 휴대폰번호, 이메일\n[학생] 이름, 생년월일, 성별',
      '보유 기간': '탈퇴 즉시 파기',
      구분: '필수'
    },
    {
      '법적 근거': '「개인정보보호법」제15조①4호',
      '수집 시점': 'SNS 연동 가입',
      '이용 목적': '간편 로그인 처리',
      '수집 항목': '연동 계정의 닉네임, 프로필 사진, 이메일, 휴대폰번호',
      '보유 기간': '탈퇴 즉시 파기',
      구분: '필수'
    },
    {
      '법적 근거': '「개인정보보호법」제15조①4호',
      '수집 시점': '프로필 설정',
      '이용 목적': '수강생 맞춤 수업 안내',
      '수집 항목': '자녀 특이사항, 관심 학습 분야',
      '보유 기간': '탈퇴 즉시 파기',
      구분: '선택'
    },
    {
      '법적 근거': '「개인정보보호법」제15조①4호,\n「전자상거래법」제6조',
      '수집 시점': '수업 신청(이벤터스 대행)',
      '이용 목적': '결제 내역 확인 및 분쟁 대응',
      '수집 항목': '신청자 이름, 연락처, 이메일, 수강생 이름·생년월일·성별',
      '보유 기간': '5년',
      구분: '필수'
    },
    {
      '법적 근거': '「개인정보보호법」제15조①4호',
      '수집 시점': '수업 진행 중',
      '이용 목적': '수업 품질 확인 및 분쟁 대응',
      '수집 항목': '수업 녹화 영상',
      '보유 기간': '30일',
      구분: '선택'
    },
    {
      '법적 근거':
        '「개인정보보호법」제15조①1호·4호,\n「통신비밀보호법」제15조의2②',
      '수집 시점': '서비스 이용 중 자동 수집',
      '이용 목적': '서비스 안정성 유지 및 품질 개선',
      '수집 항목': '접속 일시, IP주소, 접속 로그, 지역, 기기 종류, OS 버전',
      '보유 기간': '5년',
      구분: '자동'
    },
    {
      '법적 근거': '「개인정보보호법」제15조①1호·4호',
      '수집 시점': '수업 중 자동 수집',
      '이용 목적': '수업 운영 및 학습 기록 관리',
      '수집 항목': '수강생-선생님 간 채팅 내용, 업로드 파일',
      '보유 기간': '3년',
      구분: '자동'
    },
    {
      '법적 근거': '「개인정보보호법」제15조①1호',
      '수집 시점': '이벤트 참여',
      '이용 목적': '당첨자 선정 및 경품 발송',
      '수집 항목': '이름, 연락처, 주소(경품 배송 시)',
      '보유 기간': '이벤트 종료 후 30일 이내 파기',
      구분: '선택'
    }
  ];

  const s4Headers = ['제공 대상', '제공 목적', '제공 항목', '보유 기간'];
  const s4Rows: TableRow[] = [
    {
      '제공 대상': '해당 수업 담당 선생님',
      '제공 목적': '수업 진행 및 학습 지도',
      '제공 항목':
        '수강생 닉네임, 수업 참여 이력, AI탐험여권 스탬프 현황, 수업 중 채팅 내용(학습 범위 내)',
      '보유 기간': '수업 종료 후 1년, 분쟁 발생 시 해결 시까지'
    }
  ];

  const s5Headers = ['구분', '수탁업체', '위탁 내용'];
  const s5Rows: TableRow[] = [
    {
      구분: '국내',
      수탁업체: '(주)카카오',
      '위탁 내용':
        '회원 대상 고객상담 채널 운영, 알림톡 및 비즈메시지 발송 대행'
    }
  ];

  const s7Headers = ['보안 항목', '운영 방식'];
  const s7Rows: TableRow[] = [
    {
      '보안 항목': '내부 관리 체계',
      '운영 방식':
        '개인정보 보호책임자를 지정하고, 취급 직원의 역할과 권한을 명시한 내부 관리 계획을 수립·운영합니다.'
    },
    {
      '보안 항목': '암호화 저장',
      '운영 방식':
        '비밀번호를 포함한 민감 정보는 일방향 암호화(해시)하여 저장하며, 전송 구간은 TLS(HTTPS)로 보호합니다.'
    },
    {
      '보안 항목': '접근 권한 통제',
      '운영 방식':
        '개인정보 데이터베이스 접근은 담당 업무 최소 인원으로만 제한하며, 퇴직·부서 이동 시 즉시 권한을 회수합니다.'
    },
    {
      '보안 항목': '침해 대응',
      '운영 방식':
        '침입 탐지 시스템 및 보안 패치를 정기적으로 적용하여 해킹·바이러스로 인한 유출 위험을 차단합니다.'
    },
    {
      '보안 항목': '접속 기록 관리',
      '운영 방식':
        '개인정보처리시스템 접속 이력을 저장·관리하고, 기록의 위·변조 방지를 위한 별도 보안 기능을 적용합니다.'
    },
    {
      '보안 항목': '물리 보안',
      '운영 방식':
        '서버 및 관련 장비가 위치한 카페24 IDC센터의 출입 통제 정책을 준수하며, 인쇄물 등 물리적 매체는 잠금 보관합니다.'
    }
  ];

  const s9Headers = ['수집 목적', '수집 항목', '수집 방식', '보유 기간'];
  const s9Rows: TableRow[] = [
    {
      '수집 목적': '서비스 개선 및 이용 현황 분석',
      '수집 항목': '페이지 방문 이력, 수업 클릭 및 조회 기록, 기기 및 OS 정보',
      '수집 방식': '서비스 접속 시 자동 수집',
      '보유 기간': '수집 시점으로부터 최대 1년, 기간 경과 후 즉시 파기'
    }
  ];

  const s11Headers = ['항목', '내용'];
  const s11Rows: TableRow[] = [
    { 항목: '성명', 내용: '조주현' },
    { 항목: '직책', 내용: '대표' },
    { 항목: '이메일', 내용: <EmailLink email="gotoaiknow@gmail.com" /> }
  ];

  return (
    <PageShell
      title="라이브클래스 개인정보처리방침"
      announcedAt="2026-04-08"
      effectiveAt="2026-05-08"
      intro={
        <>
          주식회사 네오랩(이하 "회사")은 「개인정보 보호법」 제30조에 근거하여
          본 개인정보처리방침을 수립합니다.
          라이브클래스(liveclass.aiknow.ai.kr)를 이용하는 모든 회원의 개인정보는
          본 방침에 따라 처리되며, 회사는 수집 목적 범위 안에서만 개인정보를
          활용하고 외부 유출이 발생하지 않도록 관리합니다. 특히 초등학생 수강생
          등 <strong>만 14세 미만 아동의 개인정보 보호를 최우선</strong>으로
          고려합니다.
        </>
      }
      tocItems={tocItems}
    >
      <Article id="s1" num="1" title="수집하는 개인정보 항목 및 이용 목적">
        <p className="text-sm text-slate-700 leading-relaxed mb-4">
          회사는 라이브클래스 수업 운영에 꼭 필요한 최소한의 정보만 수집합니다.
          수집된 개인정보는 아래 명시된 목적 외에 활용되지 않으며, 모든 데이터는{' '}
          <strong>카페24 IDC센터(국내)</strong>에서 보관·처리됩니다. 선택 항목은
          동의하지 않아도 서비스 이용에 지장이 없습니다.
        </p>
        <DataTable headers={s1Headers} rows={s1Rows} />
      </Article>

      <Article id="s2" num="2" title="만 14세 미만 아동 개인정보 보호">
        <p className="text-sm text-slate-700 leading-relaxed mb-4">
          라이브클래스는 초등학생을 주요 수강 대상으로 하는 서비스로, 아동
          개인정보 보호에 각별히 유의합니다.
        </p>
        <Clause num="1.">
          <strong>계정 생성 방식</strong>: 만 14세 미만 자녀의 계정은
          법정대리인(보호자)이 직접 생성합니다. 이렇게 만들어진 계정은 보호자와
          자녀가 함께 사용할 수 있으며, 보호자는 해당 계정에서 자녀의 수업 참여
          이력, AI탐험여권 스탬프 현황 등 전체 학습 활동을 확인하고 관리할 수
          있습니다.
        </Clause>
        <Clause num="2.">
          <strong>정보 수집 최소화</strong>: 만 14세 미만 자녀의 개인정보는 수업
          일정 안내, 선생님과의 수업 진행, AI탐험여권 운영 등 라이브클래스 수업
          운영에 직접 필요한 항목만 수집합니다. 마케팅, 맞춤형 광고 등 수업 외
          목적으로는 활용하지 않습니다.
        </Clause>
        <Clause num="3.">
          <strong>법정대리인 동의</strong>: 아동의 개인정보를 최초 수집 범위를
          넘어 이용하거나 제3자에게 제공할 경우 반드시 법정대리인의 별도 동의를
          받습니다. 동의 여부는 휴대폰 본인인증 등 「개인정보 보호법 시행령」
          제17조의2에서 정한 방법으로 확인합니다.
        </Clause>
        <Clause num="4.">
          <strong>아동 직접 입력 배제</strong>: 자녀의 개인정보는 보호자가
          등록·수정하는 것을 원칙으로 하며, 아동이 직접 개인정보를 입력하는
          절차를 운영하지 않습니다.
        </Clause>
      </Article>

      <Article id="s3" num="3" title="개인정보 보유 기간 및 파기">
        <p className="text-sm text-slate-700 leading-relaxed mb-4">
          보유 기간이 만료되거나 서비스 탈퇴, 동의 철회 등으로 처리 목적이
          사라지면 해당 개인정보를 지체 없이 삭제합니다. 법령에 따라 일정 기간
          보존이 필요한 정보는 별도 데이터베이스에 분리 보관한 뒤 기간 종료 후
          파기합니다.
        </p>
        <Clause num="•">
          <strong>종이·출력물</strong>에 기재된 개인정보: 분쇄하거나 소각합니다.
        </Clause>
        <Clause num="•">
          <strong>전자 파일</strong>로 저장된 개인정보: 복원이 불가능한 기술
          방식(완전 삭제·덮어쓰기 등)을 적용하여 파기합니다.
        </Clause>
      </Article>

      <Article id="s4" num="4" title="개인정보의 제3자 제공">
        <p className="text-sm text-slate-700 leading-relaxed mb-3">
          회사는 회원의 사전 동의 없이 개인정보를 외부에 제공하지 않습니다.
          다만, 아래 경우에 한해 동의 없이 제공될 수 있습니다.
        </p>
        <div className="mb-2">
          <SubItem>
            법원·수사기관 등이 법령에 정한 절차에 따라 요청하는 경우
          </SubItem>
          <SubItem>
            회원 본인 또는 타인의 생명·신체에 급박한 위험이 있어 긴급하게 대응이
            필요한 경우
          </SubItem>
          <SubItem>공중 보건·안전을 위해 불가피한 경우</SubItem>
        </div>
        <DataTable headers={s4Headers} rows={s4Rows} />
      </Article>

      <Article id="s5" num="5" title="개인정보처리 위탁">
        <p className="text-sm text-slate-700 leading-relaxed mb-3">
          회사는 서비스 운영 중 고객 소통 업무를 아래 전문 업체에 위탁합니다.
          위탁 범위를 벗어나는 개인정보 처리는 허용하지 않으며, 위탁 업체 변경
          시 즉시 이 방침을 통해 공개합니다.
        </p>
        <DataTable headers={s5Headers} rows={s5Rows} />
      </Article>

      <Article
        id="s6"
        num="6"
        title={
          <span className="flex items-center gap-2">
            개인정보의 국외 이전
            <span className="inline-block bg-green-100 text-green-800 text-xs font-bold px-2.5 py-0.5 rounded-full">
              해당 없음
            </span>
          </span>
        }
      >
        <p className="text-sm text-slate-700 leading-relaxed">
          라이브클래스에서 수집된 개인정보는 국외로 이전되지 않습니다. 모든
          데이터는 국내 <strong>카페24 IDC센터</strong>에서만 저장·처리됩니다.
        </p>
      </Article>

      <Article id="s7" num="7" title="개인정보 보안 관리">
        <p className="text-sm text-slate-700 leading-relaxed mb-3">
          회사는 개인정보가 외부로 유출되거나 변조되지 않도록 아래와 같은 보안
          체계를 운영합니다.
        </p>
        <DataTable headers={s7Headers} rows={s7Rows} />
      </Article>

      <Article id="s8" num="8" title="쿠키 운영 및 거부 방법">
        <p className="text-sm text-slate-700 leading-relaxed mb-4">
          라이브클래스 웹사이트는 회원의 이용 편의를 높이기 위해 쿠키를
          사용합니다. 쿠키는 서버가 브라우저에 저장하는 소량의 텍스트 파일로,
          로그인 유지·수업 환경 설정 저장 등에 활용됩니다.
        </p>
        <Clause num="활용 목적">
          재방문 시 자동 로그인, 수업 설정 유지, 서비스 이용 패턴 분석을 통한
          기능 개선
        </Clause>
        <Clause num="거부 방법">
          <span>
            브라우저 설정에서 쿠키 저장을 거부할 수 있습니다. 단, 쿠키를
            차단하면 자동 로그인 등 일부 기능이 제한될 수 있습니다.
            <div className="mt-2">
              <SubItem>
                Chrome: 설정 → 개인정보 및 보안 → 쿠키 및 사이트 데이터
              </SubItem>
              <SubItem>
                Edge: 설정 → 쿠키 및 사이트 권한 → 쿠키 및 사이트 데이터 관리
              </SubItem>
              <SubItem>
                Firefox: 설정 → 개인정보 및 보안 → 향상된 추적 방지 기능
              </SubItem>
            </div>
          </span>
        </Clause>
      </Article>

      <Article id="s9" num="9" title="행태정보 수집·활용 안내">
        <p className="text-sm text-slate-700 leading-relaxed mb-3">
          회사는 수업 콘텐츠와 서비스 구조를 개선하기 위해 이용자의 행태정보를
          수집합니다.{' '}
          <strong>
            만 14세 미만 수강생에 대해서는 광고 목적의 행태정보를 수집하거나
            활용하지 않습니다.
          </strong>
        </p>
        <DataTable headers={s9Headers} rows={s9Rows} />
        <Callout>
          행태정보 수집을 원하지 않으면 브라우저 설정에서 쿠키를 비활성화하거나
          추적 방지 기능을 켜세요. 다만, 이 경우 일부 서비스 기능이 정상
          동작하지 않을 수 있습니다.
        </Callout>
      </Article>

      <Article id="s10" num="10" title="회원 및 법정대리인의 권리와 행사 방법">
        <Clause num="1.">
          회원은 자신의 개인정보에 대해{' '}
          <strong>열람 · 수정 · 삭제 · 처리정지</strong>를 언제든지 요청할 수
          있습니다. 만 14세 미만 자녀의 법정대리인도 동일한 권리를 행사할 수
          있습니다.
        </Clause>
        <Clause num="2.">
          서비스 내 설정 화면에서 직접 수정할 수 있으며, 직접 처리가 어려운 경우
          고객센터 이메일(
          <EmailLink email="gotoaiknow@gmail.com" />
          )로 요청하면 지체 없이 조치합니다.
        </Clause>
        <Clause num="3.">
          본인 외에 위임받은 대리인이 권리를 행사할 경우, 「개인정보 처리 방법에
          관한 고시」 별지 제11호 서식의 위임장을 함께 제출해야 합니다.
        </Clause>
        <Clause num="4.">
          타인의 개인정보를 침해하지 않을 의무를 지니며, 허위 정보 입력이나 타인
          정보 도용 시 서비스 이용 자격이 제한될 수 있습니다.
        </Clause>
        <Clause num="5.">
          법령에 의해 수집된 개인정보(전자상거래법상 거래 기록 등)는 보존 의무
          기간 중 삭제 요청에 응하기 어려울 수 있으며, 이 경우 사유를
          안내합니다.
        </Clause>
      </Article>

      <Article id="s11" num="11" title="개인정보 보호책임자">
        <p className="text-sm text-slate-700 leading-relaxed mb-3">
          개인정보 처리와 관련한 문의, 불만, 피해 구제 요청은 아래 책임자에게
          연락하시기 바랍니다.
        </p>
        <DataTable headers={s11Headers} rows={s11Rows} />
      </Article>

      <Article id="s12" num="12" title="개인정보 침해 시 구제 기관">
        <p className="text-sm text-slate-700 leading-relaxed mb-4">
          회사를 통해 해결되지 않는 개인정보 침해 관련 사항은 아래 전문 기관에
          신고하거나 상담을 받을 수 있습니다.
        </p>
        <div className="flex flex-col gap-2.5">
          {[
            {
              label: '① 개인정보침해신고센터',
              url: 'https://privacy.kisa.or.kr',
              phone: '118'
            },
            {
              label: '② 개인정보분쟁조정위원회',
              url: 'http://www.kopico.go.kr',
              phone: '1833-6972'
            },
            {
              label: '③ 대검찰청 사이버범죄수사단',
              url: 'http://www.spo.go.kr',
              phone: '02-3480-2000'
            },
            {
              label: '④ 경찰청 사이버안전국',
              url: 'http://www.cyber.go.kr',
              phone: '1566-0112'
            }
          ].map((agency) => (
            <div
              key={agency.phone}
              className="text-[14px] text-slate-600 flex flex-wrap gap-1.5 items-center"
            >
              <span className="font-medium text-slate-700">{agency.label}</span>
              <span className="text-slate-400">—</span>
              <a
                href={agency.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {agency.url.replace(/^https?:\/\//, '')}
              </a>
              <span className="text-slate-400">/</span>
              <span className="font-bold text-slate-700">{agency.phone}</span>
            </div>
          ))}
        </div>
      </Article>

      <Article id="s13" num="13" title="방침 변경 안내">
        <Clause num="1.">
          본 방침은 법령·서비스 변경에 따라 수시로 업데이트될 수 있습니다.
          내용이 바뀌는 경우 시행 최소 7일 전에 서비스 공지사항을 통해 알립니다.
          회원의 권리·의무에 중대한 변경이 있을 때는 30일 전에 공지하고, 등록된
          이메일로 별도 안내합니다.
        </Clause>
        <Clause num="2.">
          이전 방침은 요청 시 이메일(
          <EmailLink email="gotoaiknow@gmail.com" />
          )로 제공받을 수 있습니다.
        </Clause>
      </Article>

      <div className="bg-blue-50 border border-blue-200 rounded-xl px-7 py-5 mb-5">
        <h2 className="text-[15px] font-bold text-blue-900 mb-2">부칙</h2>
        <p className="text-[14px] text-slate-700">
          본 개인정보처리방침은 2026년 05월 08일부터 시행됩니다.
        </p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl px-7 py-6">
        <h3 className="text-[15px] font-bold text-slate-800 mb-4 pb-3 border-b border-slate-100">
          개인정보 보호책임자
        </h3>
        <dl className="grid grid-cols-[auto_1fr] gap-x-8 gap-y-2.5 text-sm">
          {[
            { key: '성명', val: '조주현' },
            { key: '직책', val: '대표' },
            { key: '연락처', val: <EmailLink email="gotoaiknow@gmail.com" /> },
            {
              key: '서비스',
              val: (
                <a
                  href="https://liveclass.aiknow.ai.kr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  https://liveclass.aiknow.ai.kr
                </a>
              )
            }
          ].map(({ key, val }) => (
            <React.Fragment key={key}>
              <dt className="text-slate-400 font-medium">{key}</dt>
              <dd className="text-slate-700">{val}</dd>
            </React.Fragment>
          ))}
        </dl>
      </div>
    </PageShell>
  );
}
